/** @typedef {keyof typeof RIGHT_DRAWER_MEMBERSHIP_DISMISS_STEP_ORDER} RightDrawerMembershipDismissStep */

export const RIGHT_DRAWER_MEMBERSHIP_DISMISS_STEP_ORDER = [
    "closeOrganizationReports",
    "closeOrganizationControls",
    "closeWorkdayControls",
    "closeSetupPanel",
    "closeDirectoryInvite",
    "closeSeniority",
    "closeDivisionAndMemberSelect",
];

/**
 * @param {Record<RightDrawerMembershipDismissStep, () => void>} deps
 */
export function applyCloseRightDrawerModulesForMembershipOpen(deps) {
    for (const step of RIGHT_DRAWER_MEMBERSHIP_DISMISS_STEP_ORDER) {
        deps[step]();
    }
}
